__turbopack_context__.v({
  "contentDescription": "scheduleDemoModal-module-scss-module__yTeruq__contentDescription",
  "modalContentContainer": "scheduleDemoModal-module-scss-module__yTeruq__modalContentContainer",
  "modalFooterContainer": "scheduleDemoModal-module-scss-module__yTeruq__modalFooterContainer",
  "modalHeader": "scheduleDemoModal-module-scss-module__yTeruq__modalHeader",
  "modalHeaderContainer": "scheduleDemoModal-module-scss-module__yTeruq__modalHeaderContainer",
  "modalHeaderStamp": "scheduleDemoModal-module-scss-module__yTeruq__modalHeaderStamp",
  "modalHeaderTitle": "scheduleDemoModal-module-scss-module__yTeruq__modalHeaderTitle",
  "scheduleDemoModal": "scheduleDemoModal-module-scss-module__yTeruq__scheduleDemoModal",
  "tenantName": "scheduleDemoModal-module-scss-module__yTeruq__tenantName",
});
